export default [
  {
    path: '/classcard/familycall/list',
    name: 'PageFamilyCall',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCall'
      ),
    meta: { modular: 29, title: '亲情通话', info: '亲情通话——首页' }
  },
  {
    path: '/familycall/guardian',
    name: 'PageFamilyCallGuardian',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallGuardian'
      ),
    meta: {
      modular: 29,
      title: '亲情通话',
      info: '亲情通话——首页-家长',
      keepAlive: true
    }
  },
  {
    path: '/classcard/familycall/setting',
    name: 'PageFamilyCallSetting',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallSetting'
      ),
    meta: { modular: 29, title: '设置', info: '亲情通话——设置' }
  },
  {
    path: '/classcard/familycall/time',
    name: 'PageFamilyCallTime',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallTime'
      ),
    meta: { modular: 29, title: '指定时间', info: '亲情通话——指定时间' }
  },
  {
    path: '/classcard/familycall/timeperiod',
    name: 'PageFamilyCallTimePeriod',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallTimePeriod'
      ),
    meta: { modular: 29, title: '指定时间', info: '亲情通话——指定时段' }
  },
  {
    path: '/classcard/familycall/frequency',
    name: 'PageFamilyCallFrequency',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallFrequency'
      ),
    meta: { modular: 29, title: '设置', info: '亲情通话——设置次数' }
  },
  {
    path: '/classcard/familycall/device',
    name: 'PageFamilyCallDevice',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallDevice'
      ),
    meta: { modular: 29, title: '通话设备', info: '亲情通话——通话设备' }
  },
  {
    path: '/classcard/familycall/mechine',
    name: 'PageFamilyCallMachine',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/familyCall/PageFamilyCallMachine'
      ),
    meta: { modular: 29, title: '亲情通话机', info: '亲情通话——亲情通话机' }
  },
  {
    path: '/familycall/paymenus',
    name: 'PagePayMenus',
    component: () =>
      import(
        /* webpackChunkName: "familycall" */ '../pages/familyCall/PagePayMenus'
      ),
    meta: {
      modular: 29,
      title: '套餐列表',
      info: '亲情通话——套餐列表',
      keepAlive: true
    }
  },
  {
    path: '/familycall/paymenus/agree',
    name: 'PagePayAgree',
    component: () =>
      import(
        /* webpackChunkName: "familycall" */ '../pages/familyCall/PagePayAgree'
      ),
    meta: {
      modular: 29,
      title: '协议',
      info: '亲情通话——协议',
      keepAlive: true
    }
  },
  {
    path: '/familycall/paycenter',
    name: 'PagePayCenter',
    component: () =>
      import(
        /* webpackChunkName: "familycall" */ '../pages/familyCall/PagePayCenter'
      ),
    meta: {
      modular: 29,
      title: '个人中心',
      info: '亲情通话——个人中心',
      keepAlive: true
    }
  },
  {
    path: '/familycall/guardian/orderList',
    name: 'PageOrderList',
    component: () =>
      import(
        /* webpackChunkName: "familycall" */ '../pages/familyCall/PageOrderList'
      ),
    meta: {
      modular: 29,
      title: '订阅记录',
      info: '亲情通话——订阅记录',
      keepAlive: true
    }
  },
  {
    path: '/familycall/orderdetail',
    name: 'PageOrderDetail',
    component: () =>
      import(
        /* webpackChunkName: "familycall" */ '../pages/familyCall/PageOrderDetail'
      ),
    meta: {
      modular: 29,
      title: '订单详情',
      info: '亲情通话——订单详情'
    }
  }
]
